import { render, staticRenderFns } from "./mirror.vue?vue&type=template&id=2bcfafe9&"
import script from "./mirror.vue?vue&type=script&lang=js&"
export * from "./mirror.vue?vue&type=script&lang=js&"
import style0 from "./mirror.vue?vue&type=style&index=0&id=2bcfafe9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports